(() => {
  if (window.ssBestsellersInitialized) return;
  window.ssBestsellersInitialized = true;
  const landingURL = (input, root) => {
    const url = new URL(input, location.origin);
    const view = root?.dataset.landingView || 'ss-bestsellers';
    url.searchParams.set('view', view);
    if (view === 'ss-bestsellers') {
      const parts = url.pathname.replace(/\/$/,'').split('/');
      if (parts[1] === 'collections') {
        const apparel = ['apparel','best-seller-apparel','tees','t-shirt','hoodie','hoodies','crewneck'].includes(parts[2]);
        const categoryTag = {tees:'tshirt','t-shirt':'tshirt',hoodie:'hoodie',hoodies:'hoodie',crewneck:'crewneck',cross:'cross',floral:'floral','mens-bible':'mens','womens-bible':'women','childrens-bible':'children'}[parts[2]];
        const tags = (parts[3] || '').split('+').filter(Boolean);
        if (categoryTag && !tags.includes(categoryTag)) tags.push(categoryTag);
        if (!tags.includes('bestseller')) tags.unshift('bestseller');
        url.pathname = '/collections/' + (apparel ? 'apparel' : 'shop-by-translation') + '/' + tags.join('+');
      }
    }
    if (view === 'ss-new') {
      const parts = url.pathname.replace(/\/$/,'').split('/');
      if (parts[1] === 'collections' && parts[2] !== 'new' && parts.length === 3) url.pathname += '/new';
    }
    if (view === 'ss-sale') {
      const parts = url.pathname.replace(/\/$/,'').split('/');
      if (parts[1] === 'collections' && parts[2] !== 'sale') {
        const tags = (parts[3] || '').split('+').filter(Boolean);
        if (!tags.includes('sale')) tags.push('sale');
        url.pathname = '/' + parts.slice(1,3).join('/') + '/' + tags.join('+');
      }
    }
    return url;
  };
  const query = () => document.querySelector('[data-ss-collection]');
  let pending, dialogDraft, previousOverflow;
  let floatingObserver, refreshFloating, filterOpener;
  const observers = new Map();
  const mobileFeatures = window.matchMedia('(max-width:700px)');
  mobileFeatures.addEventListener('change', () => refreshFloating?.());
  function positionBibleFeatures(root) {
    const grid = root?.querySelector('[data-ss-product-grid]');
    if (!grid) return;
    const features = [...grid.querySelectorAll(':scope > [data-ss-bible-feature]')];
    if (!features.length) return;
    const slots = mobileFeatures.matches ? [6,11,16,23] : [6,11,17,24];
    const order = ['builder','gift','design','translation'];
    const products = [...grid.children].filter(e => !e.hasAttribute('data-ss-bible-feature'));
    const items = [...products];
    order.forEach((id, index) => {
      const card = features.find(e => e.dataset.ssBibleFeature === id);
      if (card) items.splice(Math.min(slots[index]-1, items.length), 0, card);
    });
    grid.append(...items);
  }
  mobileFeatures.addEventListener('change', () => positionBibleFeatures(query()));

  const star = '<span class="ss-review-star" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="m12 2 3 6.3 7 .9-5 4.9 1.2 7-6.2-3.3-6.2 3.3 1.2-7-5-4.9 7-.9Z"/></svg></span>';
  function reviews(root) {
    root.querySelectorAll('.home-card-reviews').forEach(widget => {
      if (observers.has(widget)) return;
      const format = () => {
        const badge = widget.querySelector('.jdgm-prev-badge');
        if (!badge) return;
        const count = Number(badge.dataset.numberOfReviews), rating = Number(badge.dataset.averageRating);
        const text = badge.querySelector('.jdgm-prev-badge__text');
        if (!text || !Number.isFinite(rating) || count <= 0) return;
        const summary = `${rating.toFixed(1)} (${count})`;
        if (text.textContent !== summary) text.textContent = summary;
        if (!badge.querySelector('.ss-review-star')) badge.insertAdjacentHTML('afterbegin', star);
        widget.setAttribute('aria-label', `Rated ${rating.toFixed(1)} out of 5 from ${count} reviews`);
        widget.setAttribute('role', 'link');
        widget.tabIndex = 0;
      };
      format();
      const observer = new MutationObserver(format);
      observer.observe(widget, {childList:true,subtree:true,attributes:true,attributeFilter:['data-average-rating','data-number-of-reviews']});
      observers.set(widget, observer);
    });
  }
  function status(root, key) {
    const el = root.querySelector('[data-ss-status]');
    el.textContent = el.dataset[key] || '';
    el.classList.toggle('is-error', key === 'error');
  }
  function closeFilters(root, restore = true) {
    const dialog = root.querySelector('[data-ss-filter-dialog]');
    if (dialog.open) dialog.close();
    if (restore && dialogDraft) {
      const form = root.querySelector('[data-ss-filter-form]');
      form.querySelectorAll('input').forEach(input => {
        if (input.type === 'checkbox') input.checked = dialogDraft.getAll(input.name).includes(input.value);
        else input.value = dialogDraft.get(input.name) ?? '';
      });
    }
    const form = root.querySelector('[data-ss-filter-form]');
    root.querySelector('[data-ss-filter-home]').insertBefore(form, root.querySelector('.ss-sidebar-help'));
    document.body.style.overflow = previousOverflow ?? '';
    dialogDraft = null;
    refreshFloating?.();
    if (restore && filterOpener?.isConnected) filterOpener.focus({preventScroll:true});
    filterOpener = null;
  }
  function openFilters(root, translations = false) {
    filterOpener = document.activeElement;
    const form = root.querySelector('[data-ss-filter-form]'), dialog = root.querySelector('[data-ss-filter-dialog]');
    dialogDraft = new FormData(form);
    root.querySelector('[data-ss-filter-slot]').append(form);
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    refreshFloating?.();
    if (translations) {
      const group = form.querySelector('[data-filter-group="filter.p.m.custom.translation"]');
      if (group) { group.open = true; group.scrollIntoView({block:'start'}); }
    }
  }
  function syncBrowse(root) {
    const current = new URL(location.href);
    let selected = null, specificity = 0;
    root.querySelectorAll('[data-ss-browse-chip]').forEach(chip => {
      const target = new URL(chip.href, location.origin);
      const sameCollection = target.origin === current.origin && target.pathname === current.pathname;
      if (sameCollection) chip.setAttribute('data-ss-collection-link', '');
      const entries = [...target.searchParams];
      const matches = sameCollection && entries.length > 0 && entries.every(([key, value]) => current.searchParams.getAll(key).includes(value));
      if (matches && entries.length > specificity) { selected = chip; specificity = entries.length; }
      chip.classList.remove('is-active');
      chip.removeAttribute('aria-current');
    });
    const all = root.querySelector('[data-ss-browse-all]');
    const defaultTranslation = root.dataset.defaultTranslation;
    const hasFilters = [...current.searchParams.keys()].some(key => key.startsWith('filter.') && !(key === 'filter.p.m.custom.translation' && defaultTranslation && current.searchParams.getAll(key).length === 1 && current.searchParams.get(key) === defaultTranslation));
    if (!selected && !hasFilters) selected = all;
    all.classList.toggle('is-active', selected === all);
    all.removeAttribute('aria-current');
    if (selected) {
      selected.classList.add('is-active'); selected.setAttribute('aria-current', 'true');
      const rail = root.querySelector('.ss-shop-rail');
      const itemRect = selected.getBoundingClientRect(), railRect = rail.getBoundingClientRect();
      if (itemRect.right > railRect.right) rail.scrollLeft += itemRect.right - railRect.right;
      else if (itemRect.left < railRect.left) rail.scrollLeft -= railRect.left - itemRect.left;
    }
  }
  function initialize(root) {
    if (!root) return;
    positionBibleFeatures(root);
    root.classList.add('ss-js');
    root.querySelectorAll('a[data-ss-collection-link]').forEach(link=>{link.href=landingURL(link.href,root).href;});
    syncBrowse(root);
    if(root.classList.contains('ss-bestsellers-apparel')){
      const all=root.querySelector('[data-ss-browse-all]');
      const current=new URL(location.href);
      all.classList.toggle('is-active',(root.dataset.landingView === 'ss-sale' ? /\/apparel\/sale\/?$/.test(current.pathname) : root.dataset.landingView !== 'ss-new' && /\/apparel(?:\/bestseller)?\/?$/.test(current.pathname)));
    }
    root.querySelectorAll('a[data-ss-collection-link]').forEach(link=>{link.href=landingURL(link.href,root).href;});
    reviews(root);
    floatingObserver?.disconnect();
    const floating = root.querySelector('[data-ss-floating-filter]');
    const toolbar = root.querySelector('.ss-catalog-toolbar');
    const catalog = root.querySelector('.ss-catalog-layout');
    refreshFloating = () => {
      // This control is hidden on mobile; skip its layout reads after dialog writes.
      if (mobileFeatures.matches) { floating.hidden = true; return; }
      const sidebarFilters = root.querySelector('.ss-catalog-sidebar [data-ss-filter-form]');
      const sidebarVisible = sidebarFilters && getComputedStyle(sidebarFilters.closest('.ss-catalog-sidebar')).display !== 'none';
      const originalBottom = Math.max(toolbar.getBoundingClientRect().bottom, sidebarVisible ? sidebarFilters.getBoundingClientRect().bottom : 0);
      floating.hidden = originalBottom > 0 || catalog.getBoundingClientRect().bottom < 120 || root.querySelector('[data-ss-filter-dialog]').open;
    };
    if ('IntersectionObserver' in window) {
      floatingObserver = new IntersectionObserver(refreshFloating, {rootMargin:'0px 0px -120px 0px',threshold:[0,1]});
      floatingObserver.observe(toolbar);
      floatingObserver.observe(catalog);
      const sidebarFilters = root.querySelector('.ss-catalog-sidebar [data-ss-filter-form]');
      if (sidebarFilters) floatingObserver.observe(sidebarFilters);
      refreshFloating();
    }
    const dialog = root.querySelector('[data-ss-filter-dialog]');
    dialog.addEventListener('cancel', event => { event.preventDefault(); closeFilters(root); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeFilters(root);
    });
  }
  function formURL(root) {
    const url = landingURL(root.dataset.collectionUrl,root);
    const current = new URL(location.href);
    if (root.dataset.landingView === 'ss-bestsellers') url.pathname = current.pathname;
    if (root.dataset.landingView === 'ss-sale') url.pathname = current.pathname;
    if (current.searchParams.has('view')) url.searchParams.set('view', current.searchParams.get('view'));
    for (const [key, value] of new FormData(root.querySelector('[data-ss-filter-form]'))) {
      if (String(value).trim()) url.searchParams.append(key, value);
    }
    return url;
  }
  async function update(url, {more = false, history = true, replace = false} = {}) {
    let root = query();
    if (!root) return;
    pending?.abort();
    const controller = new AbortController(); pending = controller;
    url = landingURL(url,root);
    const requestURL = new URL(url);
    requestURL.searchParams.set('section_id', root.dataset.sectionId);
    root.setAttribute('aria-busy', 'true'); status(root, 'loading');
    const button = root.querySelector('[data-ss-load-more]');
    if (more && button) button.setAttribute('aria-disabled', 'true');
    const openGroups = [...root.querySelectorAll('[data-filter-group][open]')].map(e => e.dataset.filterGroup);
    try {
      const response = await fetch(requestURL, {signal:controller.signal});
      if (!response.ok) throw new Error('Collection request failed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = doc.querySelector('[data-ss-collection]');
      if (!next) throw new Error('Collection section missing');
      if (more) {
        const products = next.querySelectorAll('[data-ss-product-grid]>.home-soft-card, [data-ss-product-grid]>[data-ss-bible-feature]');
        if (!products.length) throw new Error('No products received');
        root.querySelector('[data-ss-product-grid]').append(...products);
        positionBibleFeatures(root);
        button?.remove();
        const nextButton = next.querySelector('[data-ss-load-more]');
        if (nextButton) root.querySelector('.ss-load-section').prepend(nextButton);
        reviews(root); status(root, '');
      } else {
        if (root.querySelector('[data-ss-filter-dialog]').open) closeFilters(root, false);
        observers.forEach((observer, widget) => { if (root.contains(widget)) { observer.disconnect(); observers.delete(widget); } });
        root.replaceWith(next); root = next;
        root.querySelectorAll('[data-filter-group]').forEach(e => { if (openGroups.includes(e.dataset.filterGroup)) e.open = true; });
        if (history) window.history[replace ? 'replaceState' : 'pushState']({}, '', url);
        initialize(root);
        status(root, '');
        const toolbar = root.querySelector('.ss-catalog-toolbar');
        if (toolbar.getBoundingClientRect().top < 66) toolbar.scrollIntoView({block:'start'});
      }
    } catch (error) {
      if (error.name !== 'AbortError') { root.querySelector('.ss-catalog-layout').hidden = false; status(root, 'error'); button?.removeAttribute('aria-disabled'); }
    } finally {
      if (pending === controller) { root.removeAttribute('aria-busy'); pending = null; }
    }
  }
  document.addEventListener('click', event => {
    const root = event.target.closest('[data-ss-collection]');
    if (!root) return;
    const target = event.target.closest('a,button,.home-card-reviews');
    if (!target) return;
    if(target.matches('[data-best-translations]')){const panel=root.querySelector('.ss-best-translations');panel.hidden=!panel.hidden;target.setAttribute('aria-expanded',String(!panel.hidden));}
    if (target.matches('[data-ss-open-filters],[data-ss-more-translations]')) openFilters(root, target.matches('[data-ss-more-translations]'));
    if (target.matches('[data-ss-close-filters]')) closeFilters(root);
    if (target.matches('[data-ss-clear-draft]')) {
      root.querySelectorAll('[data-ss-filter-form] input').forEach(input => { if (input.type === 'checkbox') input.checked = false; else if (input.type !== 'hidden') input.value = ''; });
    }
    if (target.matches('[data-ss-apply-filters]')) { const url = formURL(root); closeFilters(root, false); update(url); }
    if (target.matches('[data-ss-collection-link],[data-ss-load-more]') && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
      event.preventDefault();
      const url = new URL(target.dataset.url || target.href, location.origin);
      const current = new URL(location.href);
      url.searchParams.set('view',root.dataset.landingView || 'ss-bestsellers');
      update(url, {more:target.hasAttribute('data-ss-load-more')});
    }
    if (target.matches('.home-card-reviews')) {
      const link = target.closest('.home-soft-card').querySelector('.v2-product-photo');
      location.assign(link.href + '#judgeme_product_reviews');
    }
  });
  document.addEventListener('change', event => {
    const root = event.target.closest('[data-ss-collection]');
    if (!root) return;
    if (event.target.closest('[data-ss-sort-form]')) {
      const url = new URL(location.href); url.searchParams.delete('page'); url.searchParams.set('sort_by', event.target.value); url.searchParams.set('view',root.dataset.landingView || 'ss-bestsellers'); update(url);
    } else if (event.target.closest('[data-ss-filter-form]') && !root.querySelector('[data-ss-filter-dialog]').open) update(formURL(root));
  });
  document.addEventListener('submit', event => {
    const root = event.target.closest('[data-ss-collection]');
    if (!root || !event.target.matches('[data-ss-filter-form],[data-ss-sort-form]')) return;
    event.preventDefault(); update(formURL(root));
  });
  document.addEventListener('keydown', event => {
    const reviews = event.target.closest('.ss-collection .home-card-reviews');
    if (reviews && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); reviews.click(); }
  });
  window.addEventListener('popstate', () => { if (query()) update(location.href, {history:false}); });
  document.addEventListener('shopify:section:load', () => initialize(query()));
  const initial = query();
  initialize(initial);
  if (initial?.dataset.landingView === 'ss-bestsellers') {
    const canonical = landingURL(location.href, initial);
    if (canonical.pathname !== new URL(location.href).pathname) {
      initial.querySelector('.ss-catalog-layout').hidden = true;
      update(canonical, {replace:true});
    }
  }
  if (initial?.dataset.defaultTranslation) {
    const url = new URL(location.href);
    if (!url.searchParams.has('filter.p.m.custom.translation')) {
      url.searchParams.set('filter.p.m.custom.translation', initial.dataset.defaultTranslation);
      update(url, {replace:true});
    }
  }
})();
